import React from "react";
import { ButtonProps } from "./Button.types";
import { ButtonWrapper } from "./Button.styles";
import {
  Body5MediumTypography,
  Heading5SemiboldTypography,
} from "../../primitives/Typography/typographyVariants";

export const Button = (props: ButtonProps) => {
  const hasIcon = props.leftIcon || props.rightIcon;
  return (
    <ButtonWrapper {...props} data-cy={props.dataCy} hasIcon={!!hasIcon}>
      {props.leftIcon && <span className="left-icon">{props.leftIcon}</span>}
      {props.size === "small" ? (
        <Body5MediumTypography>{props.children}</Body5MediumTypography>
      ) : (
        <Heading5SemiboldTypography>
          {props.children}
        </Heading5SemiboldTypography>
      )}
      {props.rightIcon && <span className="right-icon">{props.rightIcon}</span>}
    </ButtonWrapper>
  );
};
